import './FilterCountryModal.css'

import classNames from 'classnames'
import { Checkbox, CloseButton, EmptyResults, Modal, SearchInput } from 'components'
import { selectLanguageBasedOnBrowserLocale } from 'locale'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { noop } from 'utils'

import Box from '@mui/material/Box'

import FilterCountryModalTableRow from './FilterCountryModalTableRow'

const FilterCountryModal = ({
  countries,
  filterCountryInput,
  isFetchingCountries,
  onClose,
  selectedCountries,
  setFilterCountryInput,
  setSelectedCountries,
}) => {
  const { t: translate } = useTranslation()
  const countriesFiltered = countries.filter(countryProps =>
    countryProps[`countryName${selectLanguageBasedOnBrowserLocale().toUpperCase()}`]
      .toLowerCase()
      .includes(filterCountryInput.toLowerCase()),
  )
  const [anyChanged, setAnyChanged] = useState(false)
  const [selected, setSelected] = useState(selectedCountries)
  const onSelect = countryID => {
    setAnyChanged(true)
    setSelected(selected.includes(countryID) ? selected.filter(id => id !== countryID) : [...selected, countryID])
  }
  const onConfirm = () => {
    if (anyChanged) {
      setSelectedCountries(selected)
      onClose()
    }
  }
  const onSelectAll = () => {
    setAnyChanged(true)
    setSelected(areAllCountriesSelected ? [] : countries.map(({ countryID }) => countryID))
  }
  const areAllCountriesSelected = countries.length === selected.length && countries.length > 0

  return (
    <Modal>
      <div className="filter-country-modal">
        <div className="header flex-row">
          <div className="title">{translate('rankings.modalFilterCountryTitle')}</div>

          <CloseButton onClick={onClose} />
        </div>

        <div className="filter-container">
          <SearchInput onChange={setFilterCountryInput} placeholder={translate('rankings.search')} value={filterCountryInput} />

          <div className="selection flex-row">
            <div>
              {translate('rankings.found', {
                count: <strong>{selected.length}</strong>,
                stores: translate(['rankings.companySingle', 'rankings.companyMulti', 'rankings.companyMulti2', 'n'], {
                  n: selected.length,
                }),
              })}
            </div>

            <div className="selection-actions">
              <Box
                className={classNames('selection-actions-confirm cursor-pointer', { disabled: !anyChanged })}
                onClick={onConfirm}
              >
                {translate('rankings.confirm')}
              </Box>

              <Checkbox isChecked={areAllCountriesSelected} onChange={onSelectAll} />
            </div>
          </div>
        </div>

        {countries.length > 0 &&
          countriesFiltered.map(countryProps => (
            <FilterCountryModalTableRow
              key={countryProps.countryID}
              {...countryProps}
              isChecked={selected.includes(countryProps.countryID)}
              onSelect={onSelect}
            />
          ))}
        {!isFetchingCountries && countriesFiltered.length === 0 && <EmptyResults />}
      </div>
    </Modal>
  )
}

FilterCountryModal.defaultProps = {
  countries: [],
  selectedCountries: [],
  onClose: noop,
}

FilterCountryModal.propTypes = {
  countries: PropTypes.array,
  filterCountryInput: PropTypes.string.isRequired,
  isFetchingCountries: PropTypes.bool,
  onClose: PropTypes.func,
  selectedCountries: PropTypes.arrayOf(PropTypes.number),
  setFilterCountryInput: PropTypes.func.isRequired,
  setSelectedCountries: PropTypes.func,
}

export default FilterCountryModal
